// Generated by BUCKLESCRIPT VERSION 4.0.18, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var News = require("./News.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Utils = require("../Utils.js");
var React = require("react");
var Config = require("../Config.js");
var Search = require("../Search.js");
var $$String = require("bs-platform/lib/js/string.js");
var Spinner = require("../Spinner.js");
var Dropdown = require("../Dropdown.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var ReactDom = require("react-dom");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var NewsColumns = require("./NewsColumns.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var NewsEditorial = require("./NewsEditorial.js");

function str(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("APINews");

function toolbar(editorials, campi, send, state) {
  return React.createElement("div", {
              className: "una-toolbar"
            }, React.createElement("div", {
                  className: "container"
                }, React.createElement("div", {
                      className: "una-toolbar__filters"
                    }, React.createElement("div", {
                          className: "collapse"
                        }, ReasonReact.element(undefined, undefined, Dropdown.make("btn-group", undefined, (function (v) {
                                    return Curry._1(send, /* ToggleEditorial */Block.__(2, [v]));
                                  }), state[/* editorial */1], editorials, /* array */[])), ReasonReact.element(undefined, undefined, Dropdown.make("btn-group", undefined, (function (v) {
                                    return Curry._1(send, /* ToggleCampus */Block.__(3, [v]));
                                  }), state[/* campus */2], campi, /* array */[])))), React.createElement("div", {
                      className: "una-toolbar__search"
                    }, ReasonReact.element(undefined, undefined, Search.make(state[/* search */3], (function (v) {
                                return Curry._1(send, /* Search */Block.__(0, [v]));
                              }), undefined, undefined, /* array */[])))));
}

function make(param) {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */(function (self) {
              return Utils.Fetch[/* fetch */0](Config.API[/* news */3]("https://www.unasp.br/noticias"), (function (value) {
                            return Curry._1(self[/* send */3], /* Succeed */Block.__(1, [News.Decode[/* response */5](value)]));
                          }));
            }),
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (param) {
              var state = param[/* state */1];
              var match = state[/* data */0];
              if (typeof match === "number") {
                if (match !== 0) {
                  return React.createElement("div", undefined, "Erro!");
                } else {
                  return ReasonReact.element(undefined, undefined, Spinner.make("Carregando notícias...", /* array */[]));
                }
              } else {
                var data = match[0];
                var buildList = function (filters, $$default) {
                  var __x_000 = /* record */[
                    /* value */"",
                    /* label */$$default
                  ];
                  var __x = /* :: */[
                    __x_000,
                    /* [] */0
                  ];
                  return Belt_List.concat(__x, Belt_List.makeBy(Belt_List.size(filters), (function (i) {
                                    var filter = Belt_List.getExn(filters, i);
                                    return /* record */[
                                            /* value */filter[/* id */0],
                                            /* label */filter[/* label */1]
                                          ];
                                  })));
                };
                var editorials = buildList(data[/* filters */1][/* editorials */0], "Todos os Editoriais");
                var campi = buildList(data[/* filters */1][/* campi */1], "Todos os Campi");
                var __x = data[/* news */0];
                var __x$1 = Belt_List.keep(__x, (function (editorial) {
                        var match = state[/* editorial */1];
                        if (match === "") {
                          return true;
                        } else {
                          return editorial[/* label */0] === Belt_Option.getExn(Belt_List.getBy(editorials, (function (e) {
                                              return e[/* value */0] === state[/* editorial */1];
                                            })))[/* label */1];
                        }
                      }));
                var __x$2 = Belt_List.map(__x$1, (function (editorial) {
                        var match = state[/* campus */2];
                        var tmp;
                        if (match === "") {
                          tmp = editorial[/* items */1];
                        } else {
                          var __x = editorial[/* items */1];
                          tmp = Belt_List.keep(__x, (function (i) {
                                  var match = i[/* campus */3];
                                  if (match !== undefined) {
                                    return match[/* id */0] === state[/* campus */2];
                                  } else {
                                    return false;
                                  }
                                }));
                        }
                        return /* record */[
                                /* label */editorial[/* label */0],
                                /* items */tmp
                              ];
                      }));
                var news = Belt_List.map(__x$2, (function (editorial) {
                        var match = state[/* search */3];
                        var tmp;
                        if (match === "") {
                          tmp = editorial[/* items */1];
                        } else {
                          var __x = editorial[/* items */1];
                          tmp = Belt_List.keep(__x, (function (i) {
                                  return $$String.lowercase(i[/* title */2]).includes($$String.lowercase(state[/* search */3]));
                                }));
                        }
                        return /* record */[
                                /* label */editorial[/* label */0],
                                /* items */tmp
                              ];
                      }));
                var tmp;
                if (List.length(news) === 0 || Belt_List.every(news, (function (el) {
                          return List.length(el[/* items */1]) === 0;
                        }))) {
                  tmp = React.createElement("div", {
                        className: "una-message"
                      }, React.createElement("h3", undefined, "Nenhuma notícia encontrada"), React.createElement("p", undefined, "Escolha outros filtros ou altere sua busca para encontrar mais notícias."));
                } else {
                  var match$1 = state[/* editorial */1];
                  var tmp$1 = match$1 === "" ? ReasonReact.element(undefined, undefined, NewsColumns.make(news, state[/* search */3], /* array */[])) : ReasonReact.element(undefined, undefined, NewsEditorial.make(news, state[/* search */3], /* array */[]));
                  tmp = React.createElement("div", {
                        className: "unp-news__listing"
                      }, tmp$1);
                }
                return React.createElement("div", undefined, toolbar(editorials, campi, param[/* send */3], state), React.createElement("div", {
                                className: "container"
                              }, tmp));
              }
            }),
          /* initialState */(function (param) {
              return /* record */[
                      /* data : Loading */0,
                      /* editorial */"",
                      /* campus */"",
                      /* search */""
                    ];
            }),
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */(function (action, state) {
              if (typeof action === "number") {
                return /* Update */Block.__(0, [/* record */[
                            /* data : Failed */1,
                            /* editorial */state[/* editorial */1],
                            /* campus */state[/* campus */2],
                            /* search */state[/* search */3]
                          ]]);
              } else {
                switch (action.tag | 0) {
                  case 0 : 
                      return /* Update */Block.__(0, [/* record */[
                                  /* data */state[/* data */0],
                                  /* editorial */state[/* editorial */1],
                                  /* campus */state[/* campus */2],
                                  /* search */action[0]
                                ]]);
                  case 1 : 
                      return /* Update */Block.__(0, [/* record */[
                                  /* data : Success */[action[0]],
                                  /* editorial */state[/* editorial */1],
                                  /* campus */state[/* campus */2],
                                  /* search */state[/* search */3]
                                ]]);
                  case 2 : 
                      return /* Update */Block.__(0, [/* record */[
                                  /* data */state[/* data */0],
                                  /* editorial */action[0],
                                  /* campus */state[/* campus */2],
                                  /* search */state[/* search */3]
                                ]]);
                  case 3 : 
                      return /* Update */Block.__(0, [/* record */[
                                  /* data */state[/* data */0],
                                  /* editorial */state[/* editorial */1],
                                  /* campus */action[0],
                                  /* search */state[/* search */3]
                                ]]);
                  
                }
              }
            }),
          /* jsElementWrapped */component[/* jsElementWrapped */13]
        ];
}

function renderByQuery(query) {
  var elements = document.querySelectorAll(query);
  elements.forEach((function (e) {
          ReactDom.render(ReasonReact.element(undefined, undefined, make(/* () */0)), e);
          return /* () */0;
        }));
  return /* () */0;
}

exports.str = str;
exports.component = component;
exports.toolbar = toolbar;
exports.make = make;
exports.renderByQuery = renderByQuery;
/* component Not a pure module */
